export default __webpack_public_path__ + "static/media/icon-leads.06ecbee6.webp";